"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const liskcodec_1 = require("./liskcodec");
const liskconnection_1 = require("./liskconnection");
function createLiskConnector(url, expectedChainId) {
    return {
        establishConnection: async () => liskconnection_1.LiskConnection.establish(url),
        codec: liskcodec_1.liskCodec,
        expectedChainId: expectedChainId,
    };
}
exports.createLiskConnector = createLiskConnector;
//# sourceMappingURL=liskconnector.js.map